import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=07e04747&scoped=true&lang=pug"
import script from "./Today.vue?vue&type=script&lang=js"
export * from "./Today.vue?vue&type=script&lang=js"
import style0 from "./Today.vue?vue&type=style&index=0&id=07e04747&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e04747",
  null
  
)

export default component.exports